import React, { useState, useRef, useEffect } from 'react';
import styles from './styles.module.css';

import { useTranslation } from "react-i18next";


function Input({ title, icon, placeholder = 'Entre com um valor', width = '236px', onChange, borderColor = '#888b8d', valueDefault, focus=false}) {
  const [inputValue, setInputValue] = useState(valueDefault || '');

  const inputRef = useRef(null);

  const { t } = useTranslation();


  useEffect(() => {
    setInputValue(valueDefault || '');
  }, [valueDefault])

  function change($event) {
    let val = $event.target.value;
    setInputValue(val);
    onChange(val)
  }

  return (
    <div 
      className={styles.wrapper}
      style={{
        width: width
      }} 
    >
      <label className={styles.label} htmlFor="input">
        {icon ? <img src={icon} alt={t('INPUT_ICON')} className={styles.icon} /> : ''}
        {title}
      </label>
      <input
        ref={inputRef}
        type="text"
        autoFocus={focus}
        value={inputValue}
        placeholder={placeholder}
        className={styles.input}
        style={{
          borderColor: borderColor
        }}
        onChange={e => change(e)}
      />
    </div>
  );
}

export default Input;
